import * as React from 'react';
import { ProgressIndicator, Text } from '@fluentui/react';
import { Dialog, DialogType } from 'office-ui-fabric-react';
import { t } from 'i18next';

interface IBasicBlockUI {
  blockUI: boolean;
}

const BasicBlockUI = (props: IBasicBlockUI) => {
  const modalProps = React.useMemo(
      () => ({
        isBlocking: true,
      }),
      []
  );

  // const dialogStyles: Partial<IDialogContentStyles> = { title: { backgroundColor: 'red !important' } };

  const dialogContentProps = {
    type: DialogType.largeHeader,
    titleProps: { id: 'block-dialog-id', className: 'my-loading-title' },
    title: t('Cargando')
  };

  const block = React.useMemo(() => {
    return props.blockUI;
  }, [props.blockUI]);

  return (
      <>
        {/* <DefaultButton text="Block UI" onClick={blockUI} allowDisabledFocus /> */}
        <Dialog hidden={!block} modalProps={modalProps} dialogContentProps={dialogContentProps}>
          <div className="basic-block-ui">
            <div style={{ margin: '10px 0'}}>
              <ProgressIndicator barHeight={5} />
            </div>
            <p className='my-loading-description'>
                {t('Aguarda unos instantes')}
            </p>
          </div>
        </Dialog>
      </>
  );
};
export default BasicBlockUI;
